// extracted by mini-css-extract-plugin
export default {"flexBox":"TotalAmounts_flexBox__fiWIk","container":"TotalAmounts_container__6MvCm","label":"TotalAmounts_label__CP7ig","value":"TotalAmounts_value__9HafB"};